import React from "react";
export const Home = () => {
  return <div className="container">home</div>;
};
